@if (showButton()) {
  <div
    class="alain-default__nav-item"
    (click)="openDrawer()"
    nz-tooltip
    nzTooltipTitle="How-To: related articles for this page"
    nzTooltipPlacement="bottom"
  >
    <i nz-icon nzType="book"></i>
  </div>
}

<nz-drawer
  [nzVisible]="drawerVisible()"
  nzTitle="How-To articles"
  [nzWidth]="640"
  nzPlacement="right"
  (nzOnClose)="closeDrawer()"
>
  <ng-container *nzDrawerContent>
    @if (loading()) {
      <div class="how-to-loading">
        <nz-spin nzSimple></nz-spin>
      </div>
    } @else if (totalArticleCount() === 0) {
      <p class="how-to-empty">No articles for this page.</p>
    } @else {
      @for (section of articleSections(); track section.scope) {
        <section class="how-to-scope-block">
          @if (articleSections().length > 1) {
            <p class="how-to-drawer-section-label how-to-scope-title">
              <span>{{ section.scope }}</span>
              <span class="how-to-scope-count">({{ section.articles.length }})</span>
            </p>
          }
          @if (section.articles.length > 0) {
            <nz-collapse
              [nzBordered]="false"
              class="how-to-collapse"
              [nzExpandIconPosition]="howToCollapseExpandIconPosition"
            >
              @for (a of section.articles; track a.articleUrl) {
                <ng-container>
                  <ng-template #howToArticleHeaderTpl>
                    <span class="how-to-collapse-panel-header">
                      <i
                        nz-icon
                        nzType="file-text"
                        nzTheme="outline"
                        class="how-to-collapse-panel-header-icon"
                        aria-hidden="true"
                      ></i>
                      <span class="how-to-collapse-panel-header-title">{{ a.title }}</span>
                    </span>
                  </ng-template>
                  <ng-template #howToArticleExtraTpl>
                    <button
                      type="button"
                      nz-button
                      nzType="text"
                      class="how-to-panel-external-btn"
                      nz-tooltip
                      nzTooltipTitle="Open on support site"
                      nzTooltipPlacement="top"
                      (click)="openArticleExternal($event, a.articleUrl)"
                      aria-label="Open article on support site in new tab"
                    >
                      <i nz-icon nzType="export" nzTheme="outline"></i>
                    </button>
                  </ng-template>
                  <nz-collapse-panel
                    [nzHeader]="howToArticleHeaderTpl"
                    [nzExtra]="howToArticleExtraTpl"
                    [nzActive]="isPanelActive(a.articleUrl)"
                    (nzActiveChange)="onPanelActiveChange(a, $event)"
                  >
                    @if (isArticleLoading(a.articleUrl)) {
                      <div class="how-to-panel-loading">
                        <nz-spin nzSimple></nz-spin>
                        <span>Loading…</span>
                      </div>
                    } @else {
                      @if (articleHtml(a.articleUrl); as safeHtml) {
                        <div class="how-to-article-html" [innerHTML]="safeHtml"></div>
                      } @else if (articleHasError(a.articleUrl)) {
                        <p class="how-to-panel-error">Could not load article.</p>
                        <button type="button" nz-button nzType="default" (click)="openArticle(a.articleUrl)">
                          Open in new tab
                        </button>
                      }
                    }
                  </nz-collapse-panel>
                </ng-container>
              }
            </nz-collapse>
          }
        </section>
      }
    }
  </ng-container>
</nz-drawer>
